import Component from '@glimmer/component';
import * as Icons from '../../components/icons.ts';

export interface Signature {
  Args: { icon?: keyof typeof Icons };
}

export default class LinkOrButtonIconComponent extends Component<Signature> {
  get icon() {
    return this.args.icon ? Icons[this.args.icon] : undefined;
  }

  <template>
    {{#if this.icon}}
      <this.icon aria-hidden={{true}} />
    {{/if}}
  </template>
}
